<template>
    <div>
        <Card
            :title="server.nickname || server.name"
            read="Show"
            @read="load()"
        >
            <Input text="Name" :value="server.name" disabled />
            <Input text="Nickname" :value="server.nickname" disabled />
            <Input text="Public" :value="server.publicAddress" disabled />
            <Input text="Upload" :value="server.upload | formatData" disabled />
            <Input
                text="Download"
                :value="server.download | formatData"
                disabled
            />
        </Card>
    </div>
</template>

<script>
    import Card from '@/components/general/card'
    import Input from '@/components/form/input'

    export default {
        props: ['id'],
        methods: {
            load() {
                return this.$store.dispatch(
                    'user/servers/loadByID',
                    this.server._id
                )
            }
        },
        computed: {
            server() {
                return this.$store.getters['user/servers/getByID'](this.id)
            }
        },
        components: {
            Input,
            Card
        }
    }
</script>